import { render } from "./IndexValue.vue?vue&type=template&id=566289e2"
import script from "./IndexValue.vue?vue&type=script&lang=js"
export * from "./IndexValue.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__